// ==========================================
// NEW SEARCH ARCHITECTURE - Phase 2
// search-controller.js
//
// Top-level orchestrator for the new search architecture. It wires
// together SearchEngine + Router, but on its own it does NOT:
//   - attach any event listeners
//   - intercept any form submit
//   - touch the header UI, search modal, or predictive-search
//   - perform any navigation/redirects
//
// This file also defines the single global feature flag for the new
// architecture:
//
//   window.USE_NEW_SEARCH = true;
//
// This is the search-engine replacement: with the flag TRUE,
// smart-search.js's single submit listener hands every query to this
// controller (engine + router), and none of smart-search.js's legacy
// hardcoded scoring/BRAND_COLLECTIONS logic runs. The legacy code
// stays in the file, untouched, purely as a rollback path - set this
// flag back to false to disable the new architecture instantly
// without deploying any other change.
// ==========================================

(function (global) {
  "use strict";

  // Single global feature flag. Default ON: the new, data-driven
  // engine is the live search engine. Guarded so re-including this
  // file never clobbers a value that something else may have already
  // set at runtime (e.g. a manual rollback to false).
  if (typeof global.USE_NEW_SEARCH === "undefined") {
    global.USE_NEW_SEARCH = true;
  }

  var NewSearch = (global.NewSearch = global.NewSearch || {});

  if (NewSearch.SearchController) {
    return;
  }

  /**
   * SearchController
   * options:
   *   - engine: instance of NewSearch.SearchEngine
   *   - router: instance of NewSearch.Router
   *
   * This class only computes results/destinations. It never touches
   * the DOM, never attaches listeners, and never navigates on its
   * own - all of that is left for a future phase to wire in, and only
   * once window.USE_NEW_SEARCH is explicitly turned on.
   */
  function SearchController(options) {
    options = options || {};
    this.engine = options.engine || null;
    this.router = options.router || null;
  }

  /**
   * Runs a query through the engine and router, returning a
   * destination descriptor ({ type, url }) without navigating.
   * Safe to call in isolation for testing - has no side effects
   * on the page.
   */
  SearchController.prototype.resolveQuery = function (rawQuery) {
    if (!this.engine || !this.router) {
      return Promise.resolve({
        type: "fallback",
        url: "/search?q=" + encodeURIComponent(rawQuery || ""),
      });
    }

    var router = this.router;
    return this.engine.search(rawQuery).then(function (engineResult) {
      return router.resolve(engineResult.normalizedQuery, engineResult);
    });
  };

  /**
   * Whether the new architecture is currently enabled. Provided as a
   * helper so future wiring code has one canonical place to check,
   * instead of reading window.USE_NEW_SEARCH directly everywhere.
   */
  SearchController.isEnabled = function () {
    return global.USE_NEW_SEARCH === true;
  };

  NewSearch.SearchController = SearchController;
})(window);
